module.exports = __webpack_public_path__ + "img/corp-md_2x.65fca003.jpg";